import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=8028530c&scoped=true&"
import script from "./ConfirmStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ConfirmStep.vue?vue&type=style&index=0&id=8028530c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8028530c",
  null
  
)

export default component.exports